<div *ngIf="product != null; else loading">
  <!-- <div class="row pt-2">
    <div class="col-12">
      <lib-back-button class="ml-5"></lib-back-button>
    </div>
  </div> -->

  <div class="row pt-1 product-detail-data-section">
    <!-- Product img -->
    <div class="col-xs-12 col-sm-6 container">
      <div class="row">
        <div class="mx-auto image-container">
          <img
            *ngIf="product.extra.images && product.extra.images[selectedImageIndex] as image; else noimage"
            src="https://cdn3.gung.io/fit-in/500x500/filters:etag({{
              image.s3ETag
            }}):background_color(white):format(jpeg)/{{ image.s3Uri }}"
            alt="{{ image.description }}"
            class="img-fluid"
          />
          <ng-template #noimage>
            <img
              class="card-img-top img-fluid w-100"
              src="https://cdn3.gung.io/fit-in/300x300/images/no-image.jpg"
              alt="NO IMAGE"
              class="img-fluid mx-auto d-block"
            />
          </ng-template>
        </div>
      </div>

      <!-- Product Images carousel -->
      <div *ngIf="!!carousel">
        <div *ngIf="carousel.images.length > 1" class="row pt-2">
          <button
            type="button"
            class="btn col-1"
            [disabled]="carousel.startIndex === 0"
            (click)="scrollImages('left')"
            *ngIf="!carousel.containsAll"
          >
            <i class="fa fa-chevron-left product-images-carousel"></i>
          </button>

          <div *ngFor="let image of carousel.images; trackBy: trackByFn" class="col-3 pb-1 product-detail-image">
            <img
              src="https://cdn3.gung.io/fit-in/100x100/filters:fill(white):background_color(white):etag({{
                image.s3ETag
              }}):format(jpeg)/{{ image.s3Uri }}"
              alt="{{ image.description }}"
              class="img-fluid"
              (click)="setSelectedImage(image.s3Uri)"
            />
          </div>

          <button
            type="button"
            class="btn col-1"
            [disabled]="carousel.endIndex + 1 === carousel.countAll"
            (click)="scrollImages('right')"
            *ngIf="!carousel.containsAll"
          >
            <i class="fa fa-chevron-right product-images-carousel"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Product data -->
    <div class="col-xs-12 col-sm-6">
      <div class="row">
        <div class="col-12">
          <h5 class="mb-0 product-id">
            <!-- <span>{{ 'ITEM_NO' | translate }}</span>:  -->
            {{ product.id }}
          </h5>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h1 class="product-name">{{ product.name }}</h1>
        </div>
      </div>

      <div class="row" *ngIf="getProductDescription() | async as productDescription">
        <div class="col-12">
          <div class="product-description" [innerHTML]="productDescription"></div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <i class="fas fa-box"></i>&nbsp;
          <lib-availability [availability]="availability" [isSales]="isSales" [product]="product"></lib-availability>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <h4>
            <!-- <span>{{ 'NET_PRICE' | translate }}</span>: -->
            <strong [ngClass]="{ 'is-clearance': !isReturnFlow && product.extra.ar.q_eliasson_artnr === '50' }">
              <!-- {{ price.customerNetPrice.value | gungCurrency : price.customerNetPrice.currencyCode : 'code' }} -->
              <lib-price [price]="price" type="NET"> </lib-price>
            </strong>
          </h4>
        </div>
      </div>

      <!-- <div class="row" *ngIf="price.backendPriceLevel.extra.ApproximatePrice">
        <div class="col">
          <h5>
            <span>{{ 'RRP' | translate }}</span>:
            <strong>{{price.backendPriceLevel.extra.ApproximatePrice | gungCurrency: price.backendPriceLevel.extra.CurrencyCode:'code' }}</strong>
          </h5>
        </div>
      </div> -->

      <div class="row" *ngIf="!isOnlyDisplayFlow">
        <div class="col-12">
          <cult-buy-btn [id]="product.id" [product]="product"></cult-buy-btn>
        </div>
      </div>

      <!-- Product Jeeves Details -->
      <div class="pt-2">
        <lib-gung-accordion>
          <lib-gung-accordion-item [collapsed]="false">
            <ng-template libGungAccordionHeader>{{ 'PRODUCT_DETAILS' | translate }}</ng-template>
            <ng-template libGungAccordionBody>
              <div class="table-responsive">
                <table *ngIf="productDetailsTable.length == 0" class="table table-borderless table-striped table-sm table-details">
                  <tbody>
                    <tr *ngIf="product.extra.ar.enhetskod">
                      <td>{{ 'UNIT' | translate }}</td>
                      <td>
                        {{ product.extra.ar.enhetskod }}
                      </td>
                    </tr>
                    <tr *ngIf="product.extra.ar.artfsgforp">
                      <td>{{ 'PACKAGE_SIZE' | translate }}</td>
                      <td>
                        {{ product.extra.ar.artfsgforp }}
                      </td>
                    </tr>
                    <tr *ngIf="product.extra.ar.artvikt">
                      <td>{{ 'NET_WEIGHT' | translate }}</td>
                      <td>
                        {{ product.extra.ar.artvikt }}
                      </td>
                    </tr>
                    <tr *ngIf="product.extra.ar.artbtotvikt">
                      <td>{{ 'GROSS_WEIGHT' | translate }}</td>
                      <td>
                        {{ product.extra.ar.artbtotvikt }}
                      </td>
                    </tr>
                    <tr *ngIf="product.extra.ar.artstatnr">
                      <td>{{ 'TARIC_CODE' | translate }}</td>
                      <td>
                        {{ product.extra.ar.artstatnr }}
                      </td>
                    </tr>
                    <tr *ngIf="product.extra.ar.artnrean">
                      <td>{{ 'EAN' | translate }}</td>
                      <td>
                        {{ product.extra.ar.artnrean }}
                      </td>
                    </tr>
                    <tr *ngIf="product.extra.ar.artvolym">
                      <td>{{ 'VOLUME' | translate }}</td>
                      <td>
                        {{ product.extra.ar.artvolym }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <cult-cloud-pim-product-fields
                  *ngIf="productDetailsTable.length > 0"
                  [product]="product"
                  tableClass="table-borderless table-striped"
                ></cult-cloud-pim-product-fields>
              </div>
            </ng-template>
          </lib-gung-accordion-item>
        </lib-gung-accordion>
      </div>
    </div>
  </div>

  <div class="row mt-3 product-detail-data-section">
    <div class="col-12">
      <lib-gung-tabset *ngIf="addonIds.length > 0 || pimRelatedProductsIds.length > 0">
        <lib-gung-tab *ngIf="addonIds.length > 0" [title]="'ADDONS' | translate">
          <ng-template libGungTabContent>
            <lib-product-list-by-ids [productIds]="addonIds"></lib-product-list-by-ids>
          </ng-template>
        </lib-gung-tab>
        <lib-gung-tab *ngIf="pimRelatedProductsIds.length > 0" [title]="'PRODUCT_RELATED_PRODUCTS' | translate">
          <ng-template libGungTabContent>
            <lib-product-list-by-ids [productIds]="pimRelatedProductsIds"></lib-product-list-by-ids>
          </ng-template>
        </lib-gung-tab>
      </lib-gung-tabset>
    </div>
  </div>
</div>

<ng-template #loading> LOADING... </ng-template>
